module.exports = __webpack_public_path__ + "static/media/visual-story-icon4.ca114c3f.svg";